import type { TypePolicies } from "@apollo/client";

// The revision subgraph's `Revisions` object ({ count, nodes }) carries no
// identity, so Apollo stores it inline under whichever parent field served
// it — `Deliverable.revisions`, `DeliverableSpecification.revisions` — and
// without a merge a later write of the same field replaces the object: a
// count-only read (the review panel's tree, the version list) landing on a
// parent whose revisions list is cached would discard the list's nodes. The
// type-level merge keeps the fields a narrower selection did not carry,
// under every parent the object has; a write carrying `nodes` still
// replaces them whole, so a list that shrank server-side shrinks here.
// cloud-ui composes these into its cache; hook harnesses that assert on the
// shared count build theirs from the same object.
export const revisionCacheTypePolicies: TypePolicies = {
  Revisions: { merge: true },
};
